<template>
  <div class="warp">
    <div class="top_adorn">
      <img src="@/assets/img/scroll/top.png" alt="" />
    </div>
    <div class="down_adorn">
      <img src="@/assets/img/scroll/down.png" alt="" />
    </div>
    <div class="left_adorn">
      <img src="@/assets/img/scroll/left.png" alt="" />
    </div>
    <div class="right_adorn">
      <img src="@/assets/img/scroll/right.png" alt="" />
    </div>
    <router-link class="back" to="/">
      <img src="@/assets/img/scroll/back.png" alt="" />
    </router-link>
    <vue-seamless-scroll :data="list.slice(0, 20)" class="column1" :class-option="classOption">
      <ul class="list">
        <li v-for="(item, index) in list.slice(0, 20)" :key="index">
          <router-link :to="`/digitalBooks/bookDetails/${item.id}`">
            <div class="item_img_box">
              <img :src="encodeURI(item.image)" alt="" />
            </div>
            <img class="item_shadow" src="@/assets/img/digitalBooks/shadow.png" alt="" />
          </router-link>
        </li>
      </ul>
    </vue-seamless-scroll>
    <vue-seamless-scroll :data="list.slice(20, 40)" class="column2" :class-option="classOption2">
      <ul class="list">
        <li v-for="(item, index) in list.slice(20, 40)" :key="index">
          <router-link :to="`/digitalBooks/bookDetails/${item.id}`">
            <div class="item_img_box">
              <img :src="encodeURI(item.image)" alt="" />
            </div>
            <img class="item_shadow" src="@/assets/img/digitalBooks/shadow.png" alt="" />
          </router-link>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { getBookList } from '@/api/index'

export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      list: [],
      classOption: {
        limitMoveNum: 1,
        direction: 3,
        step: 1
      },
      classOption2: {
        limitMoveNum: 1,
        direction: 2,
        step: 1
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await getBookList({
        size: 999
      })
      this.list = res.content
    }
  }
}
</script>

<style lang="less" scoped>
.warp {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/img/scroll/bg.jpg');
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 100px 0;
  position: relative;
}
.list {
  display: flex;
  li {
    width: 210px;
    height: 280px;
    background: url('../../assets/img/scroll/box.png') no-repeat center;
    margin: 0 50px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .item_img_box {
    width: 160px;
    // height: 233px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .item_shadow {
    width: 160px;
    margin-top: -8px;
  }
}
.top_adorn {
  position: absolute;
  top: 0;
}
.down_adorn {
  position: absolute;
  bottom: 0;
}
.left_adorn,
.right_adorn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.left_adorn {
  left: 0;
}
.right_adorn {
  right: 0;
}
.back {
  position: absolute;
  right: 30px;
  top: 0;
  z-index: 999;
}
</style>
